import { type JSX } from 'react'

/**
 * Small, unobtrusive corner badge shown while the portal's configured
 * Google Font is loading. Portal content renders immediately with the
 * fallback font stack — this is purely a cosmetic heads-up, not a gate.
 */
export function FontLoadingBadge(): JSX.Element {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 12px',
        borderRadius: '9999px',
        background: 'rgba(17, 24, 39, 0.85)',
        color: '#fff',
        fontSize: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}
    >
      <span
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          border: '2px solid rgba(255,255,255,0.4)',
          borderTopColor: '#fff',
          animation: 'kc3-font-badge-spin 0.8s linear infinite',
        }}
      />
      Loading font…
      <style>{'@keyframes kc3-font-badge-spin { to { transform: rotate(360deg); } }'}</style>
    </div>
  )
}
